// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cc_div{--cc-btn-primary-bg:#3a5199;--cc-btn-secondary-text:#3a5199;--cc-toggle-bg-off:rgba(145,158,166,.388);--cc-toggle-bg-on:#3a5199}.cc_div .c-bn{border-radius:1000px;cursor:pointer;font-family:Eurostile,sans-serif;text-transform:uppercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
